import { FIRST_NAME_TOKEN, LAST_NAME_TOKEN, DASHBOARD_UPDATES_TOKEN, OBFUSCATED_EMAIL, REPAIR_TYPE } from "../Settings/constants/index";
export const getRenderingParameters = (params, key) => {
  let parameterValue;

  // Error handling
  if (typeof params === "undefined") {
    return false;
  }
  if (typeof params[key] !== "undefined") {
    try {
      parameterValue = JSON.parse(params[key]);
    } catch {
      return false;
    }
  }

  // Return key value
  if (typeof parameterValue !== "undefined" && typeof parameterValue.Name !== "undefined") {
    return parameterValue.Name.toLowerCase();
  }
  if (typeof parameterValue !== "undefined") {
    return parameterValue;
  }

  // Return defaults
  switch (key) {
    case "BackgroundColour":
      {
        return "white";
      }
    case "DecorationColour":
      {
        return "lime-tint";
      }
    case "Alignment":
      {
        return "left";
      }
    case "Theme":
      {
        return "pastel-coral";
      }
    case "ComponentBackground":
      {
        return "navy";
      }
    default:
      {
        return false;
      }
  }
};
export const getRenderingParametersAsString = (params, key, defaultValue) => {
  let parameterValue;

  // Error handling
  if (typeof params === "undefined") {
    return false;
  }
  parameterValue = params[key];

  // Return key value
  if (typeof parameterValue !== "undefined") {
    return parameterValue;
  }

  // Return defaults
  return typeof defaultValue !== "undefined" ? defaultValue : false;
};
export const checkIsEditing = sitecoreContext => sitecoreContext && sitecoreContext.pageEditing;

/**
 * Replace token in Sitecore content.
 * @param {string} content - The content coming from Sitecore.
 * @param {(string|string[])} expectedToken - The token(s) to be replaced in the content.
 * @param {Object[]} data - The data holding info to be replaced by token (sitecore context with user profile or standard object).
 * @returns {string} content with replaced token(s)
 */
export const replaceTokens = (content, expectedToken, data) => {
  let newContent = content;
  if (typeof content === "undefined" || typeof expectedToken === "undefined" || typeof data === "undefined" || Object.keys(data).length === 0) {
    return false;
  }
  const replaceContent = token => {
    switch (token) {
      case FIRST_NAME_TOKEN:
        {
          if (typeof data.userProfile === "undefined") {
            return false;
          }
          const firstName = data.userProfile.firstName;
          if (typeof firstName !== "undefined" && firstName !== null) {
            newContent = newContent.replace(new RegExp(token, "g"), firstName);
          } else {
            newContent = newContent.replace(new RegExp(token, "g"), "");
          }
          break;
        }
      case LAST_NAME_TOKEN:
        {
          if (typeof data.userProfile === "undefined") {
            return false;
          }
          const lastName = data.userProfile.lastName;
          if (typeof lastName !== "undefined" && lastName !== null) {
            newContent = newContent.replace(new RegExp(token, "g"), lastName);
          } else {
            newContent = newContent.replace(new RegExp(token, "g"), "");
          }
          break;
        }
      case DASHBOARD_UPDATES_TOKEN:
        {
          if (typeof data.userProfile === "undefined") {
            return false;
          }
          const dashboardUpdates = data.userProfile.dashboardUpdates;
          if (typeof dashboardUpdates !== "undefined") {
            newContent = newContent.replace(new RegExp(token, "g"), dashboardUpdates);
          }
          break;
        }
      case OBFUSCATED_EMAIL:
        {
          const obfuscatedEmail = data.obfuscatedEmail;
          if (typeof obfuscatedEmail !== "undefined") {
            newContent = newContent.replace(new RegExp(token, "g"), obfuscatedEmail);
          }
          break;
        }
      case REPAIR_TYPE:
        {
          const repairType = data.RepairType;
          if (typeof repairType !== "undefined") {
            newContent = newContent.replace(new RegExp(token, "g"), repairType);
          }
        }
      default:
        {
          // Not a valid token
          break;
        }
    }
  };
  if (typeof expectedToken === "string") {
    replaceContent(expectedToken);
  } else if (typeof expectedToken === "object" && expectedToken.length > 0) {
    expectedToken.forEach(token => {
      replaceContent(token);
    });
  } else {
    return false;
  }
  return newContent;
};

/**
 * Match current page to a link coming from Sitecore.
 * @param {string} pageUrl - The browser url without host (pathname only).
 * @param {string} link - The link coming from Sitecore.
 * @param {Object[]} sitecoreContext - The data holding info to be replaced by token (sitecore context with user profile).
 * @returns {boolean} if true link matches the current browser url.
 */
export const isLinkActive = (pageUrl, link, sitecoreContext) => {
  if (typeof pageUrl === "undefined" || typeof link === "undefined" || typeof sitecoreContext === "undefined" || typeof sitecoreContext.language === "undefined") {
    return false;
  }
  const linkValue = link.toLowerCase();
  const itemLanguage = sitecoreContext.language;
  let url = pageUrl.toLowerCase();

  // Ensure language exist in URL because it always exists in link from SC
  if (url.indexOf(itemLanguage) === -1 && linkValue.indexOf(itemLanguage) !== -1) {
    url = "/" + itemLanguage + url;
  }
  const linkArray = url.split(linkValue);
  if (linkArray.length < 2) {
    return false;
  }

  // Remove special characters from remaining url
  const sanitisedRemainingUrl = linkArray[1].replace(/[^\w\s]/gi, "");

  // Check if there are no other pages in url
  if (sanitisedRemainingUrl === "") {
    return true;
  }
  return false;
};

/**
 * Format string to replace any tokens inside
 * @param {string} string - string to format
 * @param {array} tokenValuePairs - an array of objects containing { token, value } keypairs to be replaced
 * @returns {string} formatted string
 */
export const replaceAllTokens = (string, tokenValuePairs) => {
  let newString = string;
  if (!string || !tokenValuePairs) {
    return "";
  }
  for (let i = 0; i < tokenValuePairs.length; i += 1) {
    if (!tokenValuePairs[i].token) {
      continue;
    }
    const regex = new RegExp(tokenValuePairs[i].token, "g");
    let value = "";
    if (typeof tokenValuePairs[i].value === "string" || typeof tokenValuePairs[i].value === "number" && !isNaN(tokenValuePairs[i].value)) {
      value = tokenValuePairs[i].value;
    }
    newString = newString.replace(regex, value);
  }
  return newString;
};